export const myTableStyles = {
  tableContainer: theme => ({
    borderRadius: '12px',
    boxShadow: theme.shadows[4],
    width: '100%',
    overflow: 'auto',
    '& .MuiTable-root': {
      borderCollapse: 'separate',
      borderSpacing: 0,
      width: '100%',
      tableLayout: 'fixed',
      minWidth: '800px', // Ensure minimum width for proper column sizing
    },
  }),

  tableHead: theme => ({
    '& .MuiTableCell-root': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontWeight: 600,
      fontSize: '0.875rem',
      letterSpacing: '0.02857em',
      textTransform: 'uppercase',
      borderBottom: 'none',
      '&:first-of-type': {
        borderTopLeftRadius: '12px',
      },
      '&:last-of-type': {
        borderTopRightRadius: '12px',
      },
    },
  }),

  tableRow: theme => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
      transform: 'scale(1.005)',
      transition: 'all 0.2s ease',
    },
    '&:last-child td': {
      borderBottom: 'none',
    },
  }),

  tableCell: theme => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.primary,
    fontWeight: 400,
    letterSpacing: '0.00938em',
    '& .MuiChip-root': {
      fontSize: '0.75rem',
      fontWeight: 500,
      letterSpacing: '0.02857em',
    },
  }),
};
